import React from 'react'

const X5GroupGrayLogo: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="140"
    height="44"
    viewBox="0 0 140 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_30488_10884"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="140"
      height="44"
    >
      <path d="M140 0H0V44H140V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_30488_10884)">
      <path
        d="M33.3907 36.368L29.4535 29.6259L25.598 36.368H20.9837L26.9122 26.2118L20.8694 16.7832H25.6906L29.5625 23.0783L33.2546 16.7832H37.8689L31.924 26.5186L38.0322 36.368H33.3907Z"
        fill="#8F98A1"
      />
      <path
        d="M53.0355 29.7085C53.0355 34.0112 49.8861 36.7032 45.7602 36.7032C42.1297 36.7032 39.0603 34.6341 38.7607 30.1275H42.6979C42.9684 32.0861 44.4895 32.9336 46.1468 32.9336C48.2107 32.9336 49.1002 31.5062 49.1002 29.6598C49.1002 27.7292 47.717 26.5263 45.7893 26.5263C44.1864 26.5263 43.1281 27.3102 42.6399 28.1501H38.8751L40.1747 16.7891H52.5508L52.1388 20.5941H43.2843L42.9339 24.3544C42.9339 24.3544 43.8633 23.2319 46.6804 23.2319C50.0767 23.2319 53.0337 25.5816 53.0337 29.7234"
        fill="#8F98A1"
      />
      <path
        d="M39.2249 14.3431C37.1283 5.92466 30.4755 0 16.6691 0H0L2.26358 15.7686C3.96443 29.9975 9.24489 34.5752 18.5895 36.2607C18.6329 36.2727 18.6784 36.2735 18.7221 36.2632C18.7657 36.2527 18.8063 36.2315 18.8402 36.2013C18.874 36.171 18.9002 36.1326 18.9163 36.0894C18.9324 36.0463 18.938 35.9998 18.9327 35.9539C18.9331 35.8931 18.9161 35.8334 18.8839 35.7825C18.8516 35.7316 18.8054 35.6917 18.7511 35.6676C12.4342 32.927 11.7136 23.938 10.3649 14.9192L9.32111 7.7318H18.8364C27.6093 7.7318 34.3837 7.58962 38.6713 14.5694C38.701 14.6194 38.7423 14.661 38.7913 14.6908C38.8404 14.7205 38.8958 14.7372 38.9526 14.7396C38.9914 14.7394 39.0298 14.7312 39.0653 14.7154C39.101 14.6997 39.1332 14.6768 39.16 14.648C39.187 14.6193 39.2081 14.5852 39.222 14.5479C39.2359 14.5107 39.2424 14.4709 39.2413 14.431C39.2419 14.4011 39.2376 14.3714 39.2285 14.3431"
        fill="#8F98A1"
      />
      <path
        d="M75.6928 26.1644C75.6928 26.1644 76.6785 37.0559 65.9978 37.0559C60.3706 37.0559 56.0142 32.6128 56.0142 26.5797C56.0142 20.5465 60.3816 16.1035 66.1612 16.1035C70.6139 16.1035 74.1662 18.7449 75.5186 22.812H73.0172C71.8319 20.1406 69.2688 18.397 66.1393 18.397C61.6867 18.397 58.3884 21.8841 58.3884 26.647C58.3884 31.2659 61.5179 34.8372 66.1393 34.8372C70.0294 34.8372 72.9882 32.2817 73.3277 28.2446H65.7346V26.1868H75.6928V26.1644Z"
        fill="#8F98A1"
      />
      <path
        d="M87.6996 20.4995V22.969C87.3717 22.9304 87.042 22.9111 86.7121 22.9109C83.4701 22.9109 81.2157 25.0885 81.2157 29.1855V36.7358H78.8777V20.7633H81.2157V24.3364C82.1451 21.955 84.0057 20.4453 86.7394 20.4453C87.0602 20.4452 87.3809 20.4645 87.6996 20.5033"
        fill="#8F98A1"
      />
      <path
        d="M104.818 28.7494C104.818 33.5423 101.295 37.0555 96.8128 37.0555C92.3582 37.0555 88.8367 33.5124 88.8367 28.7494C88.8367 23.9566 92.4163 20.4414 96.8128 20.4414C101.238 20.4414 104.818 23.9566 104.818 28.7494ZM91.2037 28.7494C91.2037 32.2627 93.6833 34.762 96.8128 34.762C99.9421 34.762 102.44 32.2627 102.44 28.7494C102.44 25.2362 99.9313 22.7369 96.8128 22.7369C93.7123 22.7369 91.2037 25.2062 91.2037 28.7494Z"
        fill="#8F98A1"
      />
      <path
        d="M120.995 20.7656V36.7418H118.648V33.5746C117.606 35.6661 115.802 37.0598 113.124 37.0598C109.687 37.0598 107.627 34.7944 107.627 30.9013V20.7656H109.966V30.4373C109.966 33.2846 111.263 34.7663 113.8 34.7663C116.873 34.7663 118.648 32.5008 118.648 28.9558V20.7656H120.988H120.995Z"
        fill="#8F98A1"
      />
      <path
        d="M140 28.7524C140 33.5752 136.956 37.0584 132.728 37.0584C131.519 37.0833 130.324 36.7663 129.275 36.1417C128.228 35.5171 127.366 34.6089 126.782 33.5153V44.0008H124.442V20.7662H126.782V24.0474C127.364 22.9415 128.228 22.021 129.282 21.3861C130.335 20.7511 131.537 20.426 132.758 20.4462C136.956 20.4462 140 23.9034 140 28.7542V28.7524ZM137.641 28.7542C137.641 25.2672 135.443 22.7417 132.313 22.7417C129.184 22.7417 126.763 25.2391 126.763 28.7542C126.763 32.2694 129.158 34.7668 132.313 34.7668C135.468 34.7668 137.641 32.2675 137.641 28.7542Z"
        fill="#8F98A1"
      />
    </g>
  </svg>
)

export default X5GroupGrayLogo
